import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { saveAs as importedSaveAs } from 'file-saver';
import { sortBy } from 'lodash';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Subscription } from 'rxjs';
import { Modal } from '../../../../node_modules/ngx-modal';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../shared/constants/common.constants';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MessageService } from '../../shared/services/message.service';
import { MemberOrderType, MemberType, SearchResponseType } from '../common/constants';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { NotificationType } from '../enums/notification-types.enum';
import { DisputeTypesEnums, SourceType, TicketType } from '../enums/ticket-type.enum';
import { FBOResponse } from '../interface/fbo-response';
import { MemberSearchByFboIdResponse } from '../interface/member-search-by-fboid-response';
import { OrderDetailInformation } from '../interface/order-detail-info';
import { OrderInfoForNavigation } from '../interface/order-info-navigate';
import { ProductDisputeInfo, ProductInformation } from '../interface/product-info';
import { ProfileInformation } from '../interface/profile-info';
import { SearchRequest } from '../interface/search-request';
import { ShippingInformation } from '../interface/shipping-info';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { SearchSettingsModal } from '../models/searchSettings-modal';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { CustomerService } from '../services/customer.service';
import { DepartmentService } from '../services/department.service';
import { OrderService } from '../services/order.service';
import { AccountRestrictionStatus } from '../../common/enums/account-restricted.enum';
import { environment } from '../../../environments/environment';
@Component({
    selector: 'ticket-view',
    templateUrl: '../templates/template1/views/ticket-view.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/ticket.less', '../templates/template1/themes/default/css/my-team-tickets.component.less'
    ]
})
export class TicketViewComponent implements OnInit {
    @Input() ticketID: number;
    @Input() distributorInfo: DistributorInfo;
    @Input() tabIndex: number;
    @Input() isTeamTicket: boolean;
    @Input() isFormTicket: boolean;
    @Input() isFdTicket: boolean;
    operatingCountryId: String;
    fboProfileDetail: ProfileInformation;
    ticketingModel: any;
    sourceEnums: any = SourceType;
    existFiles: any = [];
    attachmentsLength = 0;
    ticketActivityLogList: any[] = [];
    disputeReasons: any[] = [];
    productDisputeInfoList: ProductDisputeInfo[] = [];
    isDesc: Boolean = true;
    sortColumn: String;
    isDisputeTicket: boolean;
    ticketTypeId: number;
    activetab: number;
    orderInfo: OrderDetailInformation;
    orderInfoFornavigation: OrderInfoForNavigation;
    auditLogUpdateSubscription: Subscription;
    @ViewChild('edit') edit: ElementRef;
    ticketActivityChangeData: String = '';
    @ViewChild('ticketActivityDetailsModal') ticketActivityDetailsModal: Modal;
    userInfo: UserInfo;
    isTicketEditPermission: boolean;
    ManageDepartmentPermissions: any[] = [
        Permission.MANAGE_DEPARTMENT_TICKETS_EDIT,
        Permission.MANAGE_TICKETS_CREATE
    ];
    accountRestrictionPermission: any[] = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
    storeInfo: StoreConfig;
    distributorNotFound: boolean;
    phoneNumberFormat = CommonConstant.DefaultPhoneNumberFormat;
    fboSearchResultModel: FBOResponse;
    searchComponentSettings: SearchSettingsModal;
    isoCodeThree: string;
    memberTypeEnum = MemberTypeEnum;
    accountViewPermission: boolean = false;
    accountStatus: number;
    accountRestriction:  boolean = false;
    memberDetails: any;
    enableFileUploadToPrivate: Boolean = environment.enableFileUploadToPrivate;
     constructor(private _customerservice: CustomerService, private departmentService: DepartmentService
        , private _messageService: MessageService
        , private _cacheService: CacheService, private _translatePipe: TranslateService,
        private _commonService: CommonService, private _orderservice: OrderService, private _maskPipe: MaskPipe,
      ) {

    }
    ngOnInit(): void {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.searchComponentSettings = new SearchSettingsModal(5, 0);
        this.getStoreConfig();
        this.getDisputeReasons();
        this.activetab = 1;
        this.subscribeAuditLogUpdateByTicket();
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);
    }

    getStoreConfig(): void {
        this._orderservice.getStoreInfo(CommonConstant.Default_Country).subscribe(response => {
            if (response) {
                this.storeInfo = response;
                this.getTicketById(this.ticketID);
                this.getTicketActivityLog(this.ticketID);
            }
        });
    }

     /**
    * Dispute Reasons
    */
   getDisputeReasons() {
    this._customerservice.getDisputeReasons().subscribe(response => {
        if (response) {
            this.disputeReasons = response;
        }
    });
}
    getTicketById(ticketID: number) {
        this._customerservice.getTicketById(ticketID).subscribe((response) => {
            if (response) {
                this.ticketingModel = response;
                this.isoCodeThree = this._commonService.getCountry(this.ticketingModel.countryId);
                this.operatingCountryId = response.operatingCountryId;
                this.getOperatingCountryById(this.operatingCountryId);
                this.departmentService.getTicketTypesAndSubTypes(Number(this.operatingCountryId)).subscribe(response => {
                    if (response) {
                        const ticketType = response.find((type: any) => type.value === TicketType.Order);
                        if (ticketType) {
                            this.ticketTypeId = ticketType.id;
                        }
                    }
                    if (this.ticketingModel.notes.length  > 0) {
                        this.ticketingModel.notes.sort(function  (item1,  item2) {
                            const note1 = new Date(item1.createdDate).getTime(), note2 = new Date(item2.createdDate).getTime();
                            // sort string ascending
                            if (note1 > note2) {
                                return -1;
                            } else if (note1 < note2) {
                                return 1;
                            } else {
                                return 0;
                            }
                        });
                    }
                    if (this.ticketingModel.notes) {
                        this.ticketingModel.notes.forEach(note => {
                            note.createdDate = moment.utc(note.createdDate)
                            .utcOffset(this.storeInfo.timeZoneOffset * 60).format('DD-MMM-YYYY HH:mm:ss');
                        });
                    }
                    if (this.ticketingModel.createdDate) {
                        this.ticketingModel.createdDate = moment.utc(this.ticketingModel.createdDate)
                            .utcOffset(this.storeInfo.timeZoneOffset * 60).format('DD-MMM-YYYY HH:mm:ss');
                    }
                    if (this.ticketingModel.dueDate) {
                        this.ticketingModel.dueDate = moment.utc(this.ticketingModel.dueDate)
                            .utcOffset(0).format('DD-MMM-YYYY');
                    }
                    if (this.ticketingModel.attachments) {
                        const attachments = this.ticketingModel.attachments;
                        this.existFiles = Object.assign([], attachments);
                        this.attachmentsLength = this.existFiles.length;
                    }
                    if (this.ticketingModel.typeId === this.ticketTypeId && (this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Individual_Order || this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Total_Order)) {
                        this.isDisputeTicket = true;
                        this._cacheService.set(CacheKey.IsDistributeTicket, this.isDisputeTicket);
                        this.getRecentOrderInformation();
                    }
                    this.getDistributorInfo(this.ticketingModel.memberId);
                    this.setFocusToTextBox();
                    this.getAssignedUsersByDepartments(this.ticketingModel.departmentId);
                });
            }
        });
    }
    getOperatingCountryById(operatingCountryId: String) {
        this._customerservice.getOperatingCountryById(operatingCountryId).subscribe((response) => {
            if (response) {
                const country = response;
                if (country) {
                    this.ticketingModel.operatingCountryName = country.name;
                    this.ticketingModel.operatingCountryCode = country.value;
                }
            }
        });
    }

    sortTableByColumn(property: any) {
        this.isDesc = !this.isDesc; //change the direction
        this.sortColumn = property;
        const direction = this.isDesc ? 1 : -1;

        this.ticketActivityLogList.sort(function (a, b) {
            if (a[property] < b[property]) {
                return -1 * direction;
            } else if (a[property] > b[property]) {
                return 1 * direction;
            } else {
                return 0;
            }
        });
    }

    getTicketActivityLog(ticketID) {
        if (ticketID) {
            this._customerservice.getActivityLogByTicketId(ticketID).subscribe(response => {
                if (response) {
                    this.ticketActivityLogList = response;
                    if (this.ticketActivityLogList && this.ticketActivityLogList.length > 0) {
                        this.ticketActivityLogList.forEach(x => {
                            if (x.createDate) {
                                x.createDate = moment.utc(x.createDate)
                                    .utcOffset(this.storeInfo.timeZoneOffset * 60).format('DD-MMM-YYYY HH:mm:ss');
                            }
                        });
                    }
                }
            });
        }
    }
    /**
     * Gets fbo / retail oder information from titan
     */
    getRecentOrderInformation() {
        if (this.ticketingModel && this.ticketingModel.orderId) {
            this._orderservice.getRecentOrderInformation(this.ticketingModel.orderId, this.isoCodeThree).subscribe(response => {
                if (response && response.webOrderId) {
                    this.getShipMethodInfo(response);
                    this.orderInfoFornavigation = this._customerservice.mapOrderInfoForNavigation(response);

                } else {
                    this.getOrderDetails();
                }
            }, error => {
                this.getOrderDetails();
            });
        }
    }
    /**
     * get Ship method Info
     */
    getShipMethodInfo(orderInfo: any) {
        if (orderInfo.orderShippings.length > 0 && orderInfo.orderShippings[0].shipMethodId && orderInfo.storeId) {
            const shipMethodId = orderInfo.orderShippings[0].shipMethodId;
            const storeId = orderInfo.storeId;
            this._customerservice.getShipMethodInfo(storeId, shipMethodId).subscribe(response => {
                if (response) {
                    this.orderInfo = this.mapOrderResponseToModel(orderInfo, response.shippingMethodDisplayName);
                } else {
                    this.orderInfo = this.mapOrderResponseToModel(orderInfo);
                }
            });
        } else {
            this.orderInfo = this.mapOrderResponseToModel(orderInfo);
        }

    }
    /**
     * map order response from titan to order model
     */
    mapOrderResponseToModel(orderResponse: any, shipMethodName?: string): OrderDetailInformation {
        const orderInfo = new OrderDetailInformation();
        if (orderResponse && orderResponse.createdDate) {
            orderInfo.orderDate = moment.utc(orderResponse.createdDate)
                .utcOffset(this.storeInfo.timeZoneOffset).format('DD-MMM-YYYY HH:mm:ss');
        }
        orderInfo.orderNumber = orderResponse.orderNumber || '';
        orderInfo.productInfo = [];
        orderInfo.addresses = orderResponse.addresses;
        if (orderInfo && orderInfo.addresses && orderInfo.addresses.length > 0) {
        orderInfo.address = orderInfo.addresses[0];
        }
        orderInfo.shippingInfo = new ShippingInformation();
        orderInfo.shippingInfo.shippingMethod = shipMethodName || '';
        if (orderResponse && orderResponse.orderShippings && orderResponse.orderShippings.length > 0) {
            orderInfo.shippingInfo.warehouseName = orderResponse.orderShippings[0].distributionCenter;
            orderInfo.deliveryPreferenceId = orderResponse.orderShippings[0].deliveryPreferenceId;
        } else {
            orderInfo.shippingInfo.warehouseName = null;
        }
        orderInfo.webOrderNumber = orderResponse.webOrderId;
        if (this.ticketingModel && this.ticketingModel.disputes && this.ticketingModel.disputes.length > 0
            && this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Individual_Order) {
            this.ticketingModel.disputes.forEach((product: any) => {
                if (product.ticketDisputeReasonId) {
                    const productDusputeInfo = new ProductDisputeInfo();
                    productDusputeInfo.itemNumber = product.itemNumber;
                    productDusputeInfo.productDescription = product.productDescription;
                    productDusputeInfo.quantity = product.quantity;
                    productDusputeInfo.alreadyDisputedQuantity = product.alreadyDisputedQuantity;
                    productDusputeInfo.newDisputedQuantity = product.newDisputedQuantity;
                    const disputereasonObj = this.disputeReasons.find(item => item.id === (+product.ticketDisputeReasonId));
                    if (disputereasonObj) {
                        productDusputeInfo.productDisputeReason = disputereasonObj ? disputereasonObj.value : '';
                    }
                    this.productDisputeInfoList.push(productDusputeInfo);
            }
            });
        } else if (this.ticketingModel && this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Total_Order
            && this.ticketingModel.orderReasonReasonId) {
            orderResponse.orderLineItems.forEach((product: any) => {
                const productDusputeInfo = new ProductDisputeInfo();
                productDusputeInfo.itemNumber = product.itemNumber;
                productDusputeInfo.productDescription = product.productName;
                productDusputeInfo.quantity = product.quantity;
                productDusputeInfo.alreadyDisputedQuantity = product.quantity;
                productDusputeInfo.newDisputedQuantity = 0;
                const disputereasonObj = this.disputeReasons.find(item => item.id === (+this.ticketingModel.orderReasonReasonId));
                if (disputereasonObj) {
                    productDusputeInfo.productDisputeReason = disputereasonObj ? disputereasonObj.value : '';
                }
                this.productDisputeInfoList.push(productDusputeInfo);
            });
        }
        this.productDisputeInfoList = sortBy(this.productDisputeInfoList, 'itemNumber');
        orderResponse.orderLineItems.forEach((product: any) => {
            const productInfo = new ProductInformation();
            productInfo.itemNumber = product.itemNumber;
            productInfo.cc = product.unitQualificationValue;
            productInfo.price = product.unitPaidPrice;
            productInfo.productDescription = product.productName;
            productInfo.quantity = product.quantity;
            productInfo.sku = product.itemNumber;
            orderInfo.productInfo.push(productInfo);
        });
        return orderInfo;
    }
    /*
    Get order details from AS400
    */
    getOrderDetails() {
        this._customerservice.getOrderInfoUsingWebOrderNum(this.ticketingModel.orderId.toUpperCase(), this.isoCodeThree).subscribe(response => {
            if (response) {
                this.orderInfo = response;
                this.productDisputeInfoList = response.productInfo;
                this.productDisputeInfoList.forEach((product: any) => {
                    product.itemNumber = product.sku;
                });
                this.productDisputeInfoList = sortBy(this.productDisputeInfoList, 'itemNumber');
                this.orderInfoFornavigation = this._customerservice.mapOrderInfoForNavigationForNonTitanOrder(response);
                if (!this.orderInfoFornavigation.distrubutorId) {
                    if (this.distributorInfo && this.distributorInfo.distributorId) {
                        this.orderInfoFornavigation.distrubutorId = this.distributorInfo.distributorId;
                        this.orderInfoFornavigation.name = this.distributorInfo.name;
                    }
                }
                this.orderInfo.address = this._customerservice.mapShippingAddress(this.orderInfo);
            }
        });
    }
    /*
    goto edit ticket page
    */
    editTicket() {
        const ticketTab = new TicketTabInfo();
        ticketTab.distributorID = this.distributorInfo ? this.distributorInfo.distributorId : null;
        ticketTab.editTicket = true;
        ticketTab.ticketID = this.ticketID;
        ticketTab.isTeamTicket = this.isTeamTicket;
        ticketTab.isFormTicket = this.isFormTicket;
        ticketTab.isFdTicket = this.isFdTicket;
        ticketTab.title = 'Edit Ticket - ' + this.ticketingModel.ticketNumber;
        ticketTab.disputeTicket = this.isDisputeTicket ? true : false;
        this._messageService.setCustomerServiceUserTabContent(ticketTab);
    }

    /**
        * get member info
        */
    getDistributorInfo(memberId: string) {
        if (memberId) {
            this._customerservice.getFBOProfileInfoFromTitan(memberId).subscribe(response => {
                if (response && response.isSuccess) {
                    this.distributorInfo = response;
                    if (response.firstName && response.lastName) {
                        this.distributorInfo.name = response.firstName + ' ' + (response.displayMiddleName && response.middleName ? response.middleName + ' ': '') + response.lastName;
                    }
                    this.distributorInfo.memberType = response.memberType;
                    if(this.phoneNumberFormat){
                        this.distributorInfo.contactNumber = this._maskPipe.transform(response.mobile, this.phoneNumberFormat);
                    }else{
                        this.distributorInfo.contactNumber =response.mobile;
                    }

                    this.distributorInfo.email = response.emailID;
                    const memberTypeId = response.memberTypeId;
                    const optin = response.optin;
                    this.memberDetails = response;
                    const distributorID = response.fboId;
                    this.getAccountStatus(distributorID);
                    // Check FPC condition
                    if (response.fboId) {
                        this.distributorInfo.distributorId = response.fboId;
                        this.getMemberLevelInfo(false, memberTypeId, optin);
                    }
                } else {
                    this.getSearchDistributorInfoFromAs400(memberId);
                }
            }, (error: any) => {
                this.getSearchDistributorInfoFromAs400(memberId);
            });
        } else {
            this.distributorNotFound = true;
        }
    }

 /**
     * @description
     * @date 2019-10-25
     * @private
     * @param {string} [url]
     * @memberof ViewTicket
     */
    private getSearchDistributorInfoFromAs400(distributorId: string): void {

        const searchRequest: SearchRequest = this.prepareMemberByIdRequestForSearch(distributorId);
        this._customerservice.getSearchResults(searchRequest)
            .subscribe((response: MemberSearchByFboIdResponse) => {
                if (response) {
                    if (response.status === SearchResponseType.COMPLETED) {
                        this.searchSuccess(response);
                    } else {
                        this.searchPolling(response, distributorId);
                    }
                }
            }, error => {
                this.searchErrorResponse(error);
            }, () => {
            });
    }

    closeModal(status: boolean){
        this.accountRestriction = status;
    }

     /**
     * @description
     * @date 2019-10-16
     * @param {*} error
     * @memberof EditDisputeTicket
     */
    searchErrorResponse(error: any) {
        this.distributorNotFound = true;
        if (error.validations && error.validations.length > 0) {
            this._commonService.setNotification('', error.validations[0].message, 'error', 0, true, 30);
        }
    }
     /**
     * @description
     * @date 2019-10-25
     * @param {*} response
     * @memberof ViewTicket
     */
    searchPolling(response: any, distributorId: string) {
        if ((response.status === SearchResponseType.IN_PROGRESS) || (response.status === SearchResponseType.QUEUED)) {
            if (this.searchComponentSettings.pollCount < this.searchComponentSettings.maxPollCount) {
                this.searchComponentSettings.pollCount = this.searchComponentSettings.pollCount + 1;
                this.getSearchDistributorInfoFromAs400(distributorId);
            } else {
                this.distributorNotFound = true;
                const message: any = this._translatePipe.get('ticketing-system.Member Not Found');
                this._commonService.setNotification('', message.value, 'error', 0, true, 30);
            }
        }
    }

      /**
     * @description
     * @date 2019-10-25
     * @param {*} response
     * @memberof ViewTicket
     */
    searchSuccess(response): void {

        if (response && response.fboSearchResultModelList && response.fboSearchResultModelList.length > 0) {
            this.fboSearchResultModel = response.fboSearchResultModelList[0];
            if (this.fboSearchResultModel) {
                this.distributorInfo = new DistributorInfo();
                this.distributorInfo.name = (this.fboSearchResultModel.fullName ? this.fboSearchResultModel.fullName : '') as string;
                this.distributorInfo.contactNumber = (this.fboSearchResultModel.phone ? this.fboSearchResultModel.phone : '') as string;
                this.distributorInfo.email = (this.fboSearchResultModel.email ? this.fboSearchResultModel.email : '') as string;
                this.distributorInfo.memberType = response.memberType;
                this.distributorInfo.distributorId = (this.fboSearchResultModel.fboId ? this.fboSearchResultModel.fboId : '') as string;
                if (this.fboSearchResultModel.memberType) {
                    this.getMemberLevelInfo(true);
                     // Mapping Constants to Member Type property
                    if (this.fboSearchResultModel.memberType === 'G') {
                        this.distributorInfo.memberType = MemberType.GUEST as string;
                    } else  if (this.fboSearchResultModel.memberType === 'R') {
                        this.distributorInfo.memberType =  MemberOrderType.RETAIL as string;
                    } else {
                        this.distributorInfo.memberType = this.fboSearchResultModel.memberType as string;
                    }
                }
            }
        } else {
            this.distributorNotFound = true;
        }
    }

    getMemberLevelInfo(isAS400?: boolean, memberTypeId?: number, optin?: boolean): void {
      if (isAS400) {
        this.getMemberLevelInformationFromAS400(this.distributorInfo.distributorId,
            (this.fboSearchResultModel.memberType ? this.fboSearchResultModel.memberType : '') as string);}

    }

    getMemberLevelInformationFromAS400(distibutorId: string, memberType: string) {
        if (distibutorId) {
            this._customerservice.getFBOProfileInformation(distibutorId, memberType).subscribe(response => {
                if (response && response.success) {
                    this.distributorInfo.level = response.memberLevel;
                    this.memberDetails = response;
                    const distributorID = response.fboId;
                    this.getAccountStatus(distributorID);
                }
            });
        }
    }

    getAccountStatus(distributorID){
        this._commonService.getMemberStatus(distributorID).subscribe(response => {
            if(response){
                this.accountStatus = response.status;
            } else {
                this.accountStatus = null;
            }
        })
    }

    /**
     * @description
     * @date 2019-10-16
     * @private
     * @returns {SearchRequest}
     * @memberof EditDisputeTicket
     */
    private prepareMemberByIdRequestForSearch(distributorId: string): SearchRequest {
        let searchKey: string;
        let searchValue: string;
        if (distributorId) {
            const fboId = distributorId.replace(/-|\s/g, ''); ;
            searchKey = 'FBOID';
            searchValue = fboId;
        }
        const searchRequest: SearchRequest = {
            pageNumber: 1,
            pageSize: 10,
            sort: 'DESC',
            isAdvancedSearch: false,
            searchBy: 'MEMBER',
            sortOrder: ['fboId'],
            searchCriteria: [
                {
                    searchKey: searchKey,
                    searchValue: searchValue
                }
            ]
        };
        return searchRequest;
    }

    openTicketActivityModal(changedData: String) {
        if (changedData) {
            this.ticketActivityChangeData = changedData;
            this.ticketActivityDetailsModal.open();
        } else {
            this.ticketActivityChangeData = '';
        }
    }
    closeTicketActivityPopup() {
        this.ticketActivityDetailsModal.close();
    }

    setFocusToTextBox() {
        const editElement = document.getElementById('edit');
        if (editElement) {
            setTimeout(function () {
                editElement.focus();
            }, 1000);
        }
    }
    getAssignedUsersByDepartments(departmentId: number) {

        if (departmentId) {
            if (!this.userInfo.hasSystemRole) {
                this.isTicketEditPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.ManageDepartmentPermissions[0] + ']'), AccessLevel.Department, departmentId);
            } else {
                if (this.userInfo.hasSystemRole) {
                    this.isTicketEditPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.ManageDepartmentPermissions[0] + ']'), AccessLevel.Department, departmentId);
                }
                this.isTicketEditPermission = true;
            }
            this.isTicketEditPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.ManageDepartmentPermissions[1] + ']'), AccessLevel.Customer_Service);
        }
    }

    /*
     * This method used to download the attachment
    */
    downloadDocument(url: string, fileName: string) {
      if (this.enableFileUploadToPrivate) {
        let path = new URL(url).pathname.slice(1);
        let s3Path = path.slice(0, path.lastIndexOf("/") + 1);
        this._customerservice.downloadFile(s3Path, fileName).subscribe(blob => {
          importedSaveAs(blob, fileName);
          const notification: any = this._translatePipe.get('Attachment  has been downloaded successfully');
          this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
        }, err => {
          let downloadNotification: any = this._translatePipe.get("Something Went Wrong, Please try again after some time");
          this._commonService.createNotification("", downloadNotification.value, NotificationType.ERROR);
        });
      } else {
        this._customerservice.downloadDocument(url, fileName).subscribe(blob => {
          importedSaveAs(blob, fileName);
          const notification: any = this._translatePipe.get('Attachment  has been downloaded successfully');
          this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
        });
      }
    }

    /**
     * @description
     * @date 2020-03-05
     * @param {*} tab
     * @memberof TicketViewComponent
     */
    selectTab(tab: any) {
        this.activetab = tab;
    }

    /**
    * updating Email History after send draft mail
    */
   subscribeAuditLogUpdateByTicket() {
         this.auditLogUpdateSubscription = this._messageService.getisAuditLogUpdated().subscribe(response => {
             this.getTicketActivityLog(this.ticketID);
          });
    }

     /**
     * unsubscribe
     */
    ngOnDestroy() {
        if ( this.auditLogUpdateSubscription) {
            this.auditLogUpdateSubscription.unsubscribe();
        }
    }

    navigateToFBOProfile(): void {
        if(this.accountStatus === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
            this.accountRestriction = true;
            this.memberDetails = this.memberDetails;
        } else {
            if (this.distributorInfo) {
                this._cacheService.setSessionValue(CacheKey.DistributorInfo, this.distributorInfo);
                window.open(window.location.origin + '/customerservice/search', '_blank');
                this._cacheService.removeSessionValue(CacheKey.DistributorInfo);
            } else if (this.fboProfileDetail) {
                this._cacheService.setSessionValue(CacheKey.FboProfileDetail, this.fboProfileDetail);
                window.open(window.location.origin + '/customerservice/search', '_blank');
                this._cacheService.removeSessionValue(CacheKey.FboProfileDetail);
            }
        }
    }

     /**
      * storeing ordrinfo to session
      */
     navigateToOrderInfo(): void {
         if (this.orderInfo.webOrderNumber  || this.orderInfo.orderNumber) {
            this._cacheService.setSessionValue(CacheKey.ORDER_INFO_SESSION_CODE, this.orderInfoFornavigation);
             window.open(window.location.origin + '/customerservice/search', '_blank');
            this._cacheService.removeSessionValue(CacheKey.ORDER_INFO_SESSION_CODE);
         }
    }




}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/ticket-view.component.ts